export default __webpack_public_path__ + "static/img-app-leaderboard--mobile-c5df580008a08c3910c31f6cd2e52132.webp";